import React from "react";
import { Link } from "react-router-dom";
import {
    Collapse,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";

import ThisTheme from "../../../themes/JPTheme";

import DashboardIcon from "@mui/icons-material/Dashboard";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";

const JPMenu = () => {
    const [open, setOpen] = React.useState(false);
    const handleClick = () => {
        setOpen(!open);
    };

    const menuItems = [
        {
            path: "/jp",
            label: "Dashboard",
            icon: (
                <DashboardIcon sx={{ color: ThisTheme.palette.primary.main }} />
            ),
        },

        {
            path: "/jp/jobplans",
            label: "Job Plans",
            icon: (
                <DateRangeOutlinedIcon
                    sx={{ color: ThisTheme.palette.primary.main }}
                />
            ),
        },
    ];

    return (
        <List
            component="nav"
            className="menu-list"
            aria-label="Job planning menu"
            data-cy="menu_jp"
        >
            <ListItem
                component="div"
                onClick={handleClick}
                aria-expanded={open}
                disablePadding
            >
                <ListItemButton>
                    <ListItemIcon>
                        <ListAltOutlinedIcon
                            sx={{ color: ThisTheme.palette.primary.main }}
                        />
                    </ListItemIcon>
                    <ListItemText primary="Job Planner" />
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItemButton>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="nav" disablePadding>
                    {menuItems &&
                        menuItems.length &&
                        menuItems.map(({ path, icon, label }) => (
                            <ListItem
                                key={path}
                                component={Link}
                                to={path}
                                disablePadding
                            >
                                <ListItemButton className="nested">
                                    <ListItemIcon>{icon}</ListItemIcon>
                                    <ListItemText>{label}</ListItemText>
                                </ListItemButton>
                            </ListItem>
                        ))}
                </List>
            </Collapse>
        </List>
    );
};

export default JPMenu;
